import { useCallback, useState } from "react";
import { ClientDTO } from "../../openapi/requests";
import ExportKingfisherProjects from "../tools/ExportKingfisherProjects";
import ImportClientAssets from "../tools/ImportClientAssets";
import saveAs from "file-saver";
import { Button, Card, Flex, Space } from "antd";
import { BASE_PATH } from "../../Environment";

const ClientImportExport: React.FC<{client: ClientDTO}> = ({client}) => {

    const [ importClientAssetsOpen, setImportClientAssetsOpen] = useState(false)    

    const [ exportProjectsOpen, setExportProjectsOpen] = useState(false)

    const exportClientAssets = useCallback(() => {
        const token = localStorage.getItem("accessToken");

        fetch(`${BASE_PATH}/Export/client/assets/${client?.id}`, {
        method: "get",
        headers: {
            Authorization: "Bearer " + token,
        },
        })
        .then((response) => {
            return response.blob();
        })
        .then((blob) => {
            saveAs(blob, "export.xlsx");
        });
    }, [client?.id]);


    return (
        <>
            <ImportClientAssets clientId={client?.id ?? 0} isOpen={importClientAssetsOpen} onClose={() => setImportClientAssetsOpen(false)} />
            <ExportKingfisherProjects isOpen={exportProjectsOpen} onClose={() => setExportProjectsOpen(false)} />
            <Space orientation="vertical" style={{display: "flex"}}>
                <Card title="Import">
                      <Space>
                    <Button type="primary" onClick={() => setImportClientAssetsOpen(true)}>Client Assets</Button>
                    </Space>
                </Card>
                <Card title="Export">
                    <Space>
                    <Button type="primary" onClick={() => exportClientAssets()}>Client Assets</Button>
                    {client.name.toLowerCase() === "kingfisher" && <Button type="primary" onClick={() => setExportProjectsOpen(true)}>Kingfisher Projects</Button>}
                    </Space>
                </Card>
            </Space>            
        </>
    )
}

export default ClientImportExport;